<template>
  <div class="wrap">
    <div class="content">
      <div class="head">
        <SysHead></SysHead>
      </div>
      <div ref="body" class="body">
        <div v-show="project == 'zh'">
          <ProjectZh></ProjectZh>
        </div>
        <div v-show="project == 'jk'">
          <ProjectJk></ProjectJk>
        </div>
        <div v-show="project == 'qx'">
          <ProjectQx></ProjectQx>
        </div>
        <div v-show="project == 'pl'">
          <ProjectPl></ProjectPl>
        </div>
        <div v-show="project == 'js'">
          <ProjectJS></ProjectJS>
        </div>
        <div v-show="project == 'sm'">
          <ProjectSM></ProjectSM>
        </div>
        <div v-show="project == 'zn'">
          <ProjectZn></ProjectZn>
        </div>
      </div>
    </div>
    <div class="menu">
      <SysMenu :project="project" @setProject="setProject"></SysMenu>
    </div>
  </div>
</template>

<script>
import SysHead from "./head.vue";
import SysMenu from "./menu.vue";
import ProjectZh from "./project/zh.vue";
import ProjectJk from "./project/jk.vue";
import ProjectQx from "./project/qx.vue";
import ProjectPl from "./project/pl.vue";
import ProjectJS from "./project/js.vue";
import ProjectSM from "./project/sm.vue";
import ProjectZn from "./project/zn/list.vue";
export default {
  components: {
    SysHead,
    SysMenu,
    ProjectZh,
    ProjectJk,
    ProjectQx,
    ProjectPl,
    ProjectJS,
    ProjectSM,
    ProjectZn,
  },
  data() {
    return {
      project: "zh",
    };
  },
  created() {
    let query = {
      ...this.$route.query,
    };
    this.$store.dispatch("reportData", query);
  },
  watch: {
    project(v) {
      this.$refs.body.scrollTo(0, 0);
    },
  },
  methods: {
    setProject(project) {
      this.project = project;
    },
  },
};
</script>

<style scoped lang="scss">
.wrap {
  display: grid;
  grid-template-columns: auto 55px;
  height: 100vh;
  overflow: hidden;
  .content {
    .body {
      height: calc(100vh - 90px);
      overflow: auto;
    }
  }
  .menu {
    margin-top: 30px;
    padding: 50px 0;
    text-align: center;
    border-radius: 15px 15px 0 0;
    background: #f5f5f5;
    overflow: auto;
  }
}
</style>